<section class="top-products-section" id="top-products">
  <div class="top-products-section__header">
    <div class="header-content">
      <pwj-sections-title class="header-content__title">
        <span class="title-second-word">{{
          'global.products' | translate
        }}</span>
      </pwj-sections-title>
    </div>
    <a
      [routerLink]="isPortfolioMode() ? '/products' : 'products'"
      [scrollTop]="true">
      <pwj-button
        class="header-btn"
        size="large"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true">
        {{
          (isPortfolioMode() ? 'global.viewAllInWejoiner' : 'global.viewAll')
            | translate
        }}
      </pwj-button>
    </a>
  </div>
  <div class="top-products-section__content">
    @if (!productsLoading()) {
      @if ((topProducts()?.length || 0) > 0) {
        <ul class="top-products-list">
          @for (product of topProducts()?.slice(0, 4); track product) {
            <li class="top-products-list__item">
              <pwj-product-card [productCardData]="product"></pwj-product-card>
            </li>
          }
        </ul>
      } @else {
        <div>
          <!-- no content component -->
          <pwj-no-content message="products.noProducts"></pwj-no-content>
        </div>
      }
    } @else {
      <div>
        <pwj-product-card-skeleton
          [count]="4"
          containerClasses="flex flex-wrap gap-14 mt-46"></pwj-product-card-skeleton>
      </div>
    }
  </div>
</section>
